import { useEffect, useRef } from 'react';
import styles from './Success.module.css';

const Success = ({ scale = 0.5 }) => {

    const iconRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry.isIntersecting) {
                entry.target.classList.add(styles["animated"]);
            }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1
        });

        if (iconRef.current) {
            observer.observe(iconRef.current);
        }

        return () => {
            observer.unobserve(iconRef.current);
        };
    }, [])

    return (
        <div className={styles["sa"]} ref={iconRef} style={{ transform: `scale(${scale})` }}>
            <div className={styles["sa-success"]}>
                <div className={styles["sa-success-tip"]}></div>
                <div className={styles["sa-success-long"]}></div>
                <div className={styles["sa-success-placeholder"]}></div>
                <div className={styles["sa-success-fix"]}></div>
            </div>
        </div>
    );
};

export default Success;
